import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asbsbtcontact',
  templateUrl: './asbsbtcontact.component.html',
  styleUrls: ['./asbsbtcontact.component.scss']
})
export class AsbsbtcontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
